import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { componentIntermediateSelector } from 'state-management/actions'
import { getGlobalProps } from 'state-management/selectors'
import Form from 'react-bootstrap/Form';
import Label from './Label';
const LiveCheckBox = ({ title }) => {
    const globalProps = useSelector(getGlobalProps)
    const dispatch = useDispatch();
    let _title = title || <Label data='LabelLive' />
    const handleOnchange = (e) => {
        // Use Redux to store live checkbox.
        //When isLive, selected intermediate has to be current intermediate
        let intermediateSelector = Object.assign({}, globalProps.intermediateSelector);
        intermediateSelector.isLive = e.target.checked;
        if (e.target.checked) {
            intermediateSelector.selected = intermediateSelector.current
        }
        dispatch(componentIntermediateSelector(intermediateSelector))
    }

    return (
        <div className="mirs-liveCheckBox-main d-flex justify-content-end">
            <Form.Check checked={globalProps.intermediateSelector.isLive} label={_title} name="liveCheckBox" type="checkbox" onChange={(e) => handleOnchange(e)} />
        </div>
    );
}

export default LiveCheckBox;



